// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  cumulativeDataUrl: 'https://disease.sh/v3/covid-19/all',
  vaccinesUrl: 'https://disease.sh/v3/covid-19/vaccine',
  vaccinesCoverageUrl: 'https://disease.sh/v3/covid-19/vaccine/',
  therapeuticsUrl: 'https://disease.sh/v3/covid-19/therapeutics',
  countryHistorical: 'https://disease.sh/v2/historical/',
  herokuDataUrl: 'https://coronavirus-19-api.herokuapp.com/countries',
  dailyTimeSeriesUrl: 'https://covid19.mathdro.id/api/daily',
  dailyTimeSeriesUrlDiseaseSh:
    'https://disease.sh/v3/covid-19/historical/all?lastdays=660',
  ninja: 'https://disease.sh/v2/',
  travelAlertInfoUrl: 'https://api.coronatracker.com/v1/travel-alert',
  covidNewsFeedUrl:
    'https://api.coronatracker.com/news/trending?limit=19&offset=0&language=en',
  athensMobilityData:
    'https://disease.sh/v3/covid-19/apple/countries/Greece/Athens',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
